import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../core'
import * as subawards from '../subawards'

export const RESOURCE = {
  payload: {
    description:
      'Used to assess the overall risk of a subaward for the purpose of subrecipient monitoring',
    dimension: subawards.RESOURCE.payload,
    name: 'Subaward Risk Assessment',
    partialId: PartialId.Standard.create('subaward_risk_survey'),
  },
  type: core.quiver.Resource.Type.DmsSnapshot,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsSnapshot>
